// extracted by mini-css-extract-plugin
export default {"teller":"Wishlist_teller__8TGt7","grid":"Wishlist_grid__s4S-R"};